export const searchFieldCompanyOptions = [
  { label: "Company Name", value: "company_name" },
  { label: "Domain Name", value: "domain" }
];
